import { View } from '@react-pdf/renderer'
import { ReactElement, ReactNode } from 'react'

import { pdfStyles } from './utils/pdfStyles'

interface SalesReportPdfTableRowProps {
  children: ReactNode
  wrap?: boolean
}

export const SalesReportPdfTableRow = ({ children, wrap = false }: SalesReportPdfTableRowProps): ReactElement => {
  return (
    <View style={pdfStyles.tableRow} wrap={wrap}>
      {children}
    </View>
  )
}
